import React from 'react';
import DatahubAPI from '../../../api/DatahubAPI';
import CustomAutocomplete from '../../Common/MUICustomAutocomplete';

interface IWatchlistOptions {
  formValues: any;
  setFormValues: any;
  selectedIndex: any;
  watchlistPrimaryOpts: any;
  agencyOpts: any;
  setAgencyOpts: any;
  listOpts: any;
  setListOpts: any;
  toClear: any;
}

const WatchlistOptions: React.FC<IWatchlistOptions> = ({
  formValues,
  setFormValues,
  selectedIndex,
  watchlistPrimaryOpts,
  agencyOpts,
  setAgencyOpts,
  listOpts,
  setListOpts,
  toClear,
}) => {
  const handleCountrySelect = async(e: any) => {
    const obj: any = {
      ...formValues,
      country: e,
      govtAgency: [],
      listName: [],
    };
    setFormValues(obj);
    if (obj && obj.country.length !== 0) {
      setAgencyOpts({ isLoading: true, data: {} });
      setListOpts({ isLoading: true, data: {} });
      const res = await DatahubAPI.watchlist({
        indexName: selectedIndex,
        listCountry: obj.country,
      });
      const addedBuckets: any = [];
      if (res?.result) {
        res?.result?.result?.body?.aggregations?.countryAgg?.buckets.map(
          (bucket: any) => {
            addedBuckets.push(bucket.govtAgencyAgg.buckets);
          },
        );
      }
      setAgencyOpts({ isLoading: false, data: addedBuckets.flat() });
    }
  };

  const handleAgencySelect = async(e: any) => {
    const obj: any = {
      ...formValues,
      govtAgency: e,
      listName: [],
    };
    setFormValues(obj);
    if (obj && obj.country.length !== 0) {
      setListOpts({ isLoading: true, data: {} });
      const res = await DatahubAPI.watchlist({
        indexName: selectedIndex,
        govtAgency: obj.govtAgency,
      });
      const addedBuckets: any = [];
      if (res?.result) {
        res?.result?.result?.body?.aggregations?.countryAgg?.buckets.map(
          (bucket: any) => {
            bucket.govtAgencyAgg.buckets.map((secondBucket: any) => {
              addedBuckets.push(secondBucket.listNameAgg.buckets);
            });
          },
        );
      }
      setListOpts({ isLoading: false, data: addedBuckets.flat() });
    }
  };

  const handleListName = async(e: any) => {
    setFormValues({ ...formValues, listName: e });
  };

  return (
    <div className='wl-dropdown-container'>
      {!watchlistPrimaryOpts.isLoading && (
        <CustomAutocomplete
          options={watchlistPrimaryOpts.data.countryAgg.buckets}
          placeholder='Sanctioning Country'
          onChange={handleCountrySelect}
          toClear={toClear}
        />
      )}
      <CustomAutocomplete
        options={!agencyOpts.isLoading ? agencyOpts.data : []}
        placeholder='Sanctioning Agency / Department'
        onChange={handleAgencySelect}
        toClear={toClear}
      />
      <CustomAutocomplete
        options={!listOpts.isLoading ? listOpts.data : []}
        placeholder='List Name'
        onChange={handleListName}
        toClear={toClear}
      />
    </div>
  );
};

export default WatchlistOptions;
